import { Train } from "../Reducers/types";
import { SET_TRAIN } from "./constants";

export const setTrainData = (train: Train) => {
  const action = { type: SET_TRAIN, train: train };
  return action;
};
